import { ProviderDirectory } from '../components/ProviderDirectory'

export function SettingsProviders() {
  return (
    <div className="settings-content" role="main">
      <div className="settings-header">
        <div>
          <h1>Provider Directory</h1>
          <p className="settings-subtitle">Manage referral providers and organizations</p>
        </div>
      </div>
      <ProviderDirectory />
    </div>
  )
}
